<script>
    export default {
        props: {
            windowOpenAddToPr: {
                type: Boolean
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                selectedMediaData: [],
                tree: null,
                selectedTreeItems: [],
            }
        },
        computed: {
            mediaSelected: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            previewMedia() {
                let previewMedia = this.selectedMediaData;

                // Used to show media immediatly after opening the lightbox, instead of waiting for ajax call
                if (!previewMedia.length) {
                    previewMedia = _.map(this.mediaSelected, function (id) {
                        return {id};
                    })
                }

                return _.slice(previewMedia, 0, 7);
            }
        },
        watch: {
            windowOpenAddToPr: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (newValue) {
                        this.loadData();

                        this.$nextTick(() => {
                            $(this.$refs.addToPressdatabase).on('hidden.bs.modal', () => {
                                this.close();
                            }).modal('show');
                        });
                    } else if (oldValue) {
                        $(this.$refs.addToPressdatabase).modal('hide');
                        scoopOS.deselectAll('medias');
                    }
                },
            }
        },
        methods: {
            loadData() {
                axios.get(Scoop.baseUrl + '/pr/components/add-media-to-pressdatabase').then((response) => {
                    this.selectedMediaData = response.data.selectedMediaData;
                    this.tree = response.data.tree;
                    this.selectedTreeItems = response.data.selectedTreeItems;

                    this.$nextTick(() => {
                        $('[data-toggle="tooltip"]').tooltip();

                        $('#jstree').jstree({
                            'plugins': ['checkbox'],
                            'core': {
                                'themes': {
                                    'name': 'proton',
                                    'responsive': true
                                },
                                'multiple': true,
                                'check_callback': true
                            },
                            'checkbox': {
                                'visible': false,
                                'cascade': 'undetermined',
                                'three_state': false,
                                'whole_node': true
                            }
                        });
                        $('#jstree').on("changed.jstree", (e, data) => {
                            if (data.action === 'select_node' && data.node) {
                                this.selectedTreeItems = $("#jstree").jstree("get_selected");
                            }
                        });
                    });
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                    console.log(error);
                });
            },
            publish() {
                let parameter = {
                    'selectedTreeItems': this.selectedTreeItems
                };

                axios.post(Scoop.baseUrl + '/pr/components/add-media-to-pressdatabase', parameter).then((response) => {
                    toastr.info('Successfully added media to press database');
                    this.close();
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                    console.log(error);
                });
            },
            close() {
                this.$emit('close');
            }
        },
    }
</script>
<template>
    <div ref="addToPressdatabase" class="modal inmodal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Add media to {{__('scoop-pr.dashboard.headline')}}</h4>
                    <small class="font-bold">
                        <img
                                v-if="tree"
                                v-for="media in previewMedia"
                                :src="media.previewImageUrl"
                                width="30" height="30"
                                class="img-thumbnail img-md m-r-xs"
                                :class="{ 'panel-primary bg-danger': false }"
                        >
                        <span v-if="mediaSelected.length > previewMedia.length">
                            + {{ mediaSelected.length - previewMedia.length }}
                        </span>
                        <div v-if="!tree">
                            <i class="fa fa-spinner fa-spin fa-5x fa-fw"></i>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </small>
                </div>
                <div v-if="tree" class="modal-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div id="jstree" v-if="tree">
                                <ul>
                                    <tree-node
                                            class="jstree-open"
                                            :selected="selectedTreeItems"
                                            :node="tree"
                                            :label="__('scoop-pr.dashboard.headline')"
                                    >
                                    </tree-node>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="pull-left">
                        <button type="button" class="btn btn-white" data-dismiss="modal" v-text="__('scoop-pr.general.close')"></button>
                    </div>
                    <button @click.prevent="publish" type="button" class="btn btn-primary" :disabled="!tree">
                        Publish in {{ __('scoop-pr.dashboard.headline') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
